import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/yonrin-header/suzuki_logo.png'


const _withScopeId = (n: any) => (_pushScopeId("data-v-5edeee74"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<div id=\"yonrin-global_header\" class=\"yonrin-mf_finder_container pc tab\" data-v-5edeee74><nav class=\"yonrin-global-header-nav\" id=\"yonrin-search\" data-v-5edeee74><ul class=\"yonrin-logoarea\" data-v-5edeee74><li data-v-5edeee74><a class=\"yonrin-navbar-brand\" href=\"https://www.suzuki.co.jp/car/\" data-v-5edeee74><img src=\"" + _imports_0 + "\" alt=\"スズキ株式会社\" data-v-5edeee74></a></li></ul></nav></div>", 1)
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "yonrin-header" }, [
  /*#__PURE__*/_createElementVNode("nav", { class: "pc tab yonrin-header_nav" }, [
    /*#__PURE__*/_createElementVNode("ul", { class: "yonrin-global_nav" }, [
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createElementVNode("a", { href: "https://www.suzuki.co.jp/car/lineup/" }, [
          /*#__PURE__*/_createTextVNode("ライン"),
          /*#__PURE__*/_createElementVNode("br", { class: "tab" }),
          /*#__PURE__*/_createTextVNode("アップ")
        ])
      ]),
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createElementVNode("a", {
          href: "https://www.suzuki.co.jp/dealer/Map/getPref/shop",
          onClick: "s.linkTrackVars=prop13;s.prop13=四輪車トップ conv 販売店検索;s.tl(this, o, 四輪車トップ conv 販売店検索);",
          target: "_blank"
        }, [
          /*#__PURE__*/_createTextVNode("販売店"),
          /*#__PURE__*/_createElementVNode("br", { class: "tab" }),
          /*#__PURE__*/_createTextVNode("検索")
        ])
      ]),
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createElementVNode("a", {
          href: "https://www.suzuki.co.jp/car/purchase/democar/",
          onClick: "s.linkTrackVars=prop13;s.prop13=四輪車トップ conv 展示車・試乗車検索;s.tl(this, o, 四輪車トップ conv 展示車・試乗車検索);"
        }, [
          /*#__PURE__*/_createTextVNode("展示車・"),
          /*#__PURE__*/_createElementVNode("br", { class: "tab" }),
          /*#__PURE__*/_createTextVNode("試乗車検索")
        ])
      ]),
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createElementVNode("a", {
          href: "https://www.suzuki.co.jp/car/purchase/estimate/",
          onClick: "s.linkTrackVars=prop13;s.prop13=四輪車トップ conv オンライン見積り;s.tl(this, o, 四輪車トップ conv オンライン見積り);"
        }, [
          /*#__PURE__*/_createTextVNode("オンライン"),
          /*#__PURE__*/_createElementVNode("br", { class: "tab" }),
          /*#__PURE__*/_createTextVNode("見積り")
        ])
      ]),
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createElementVNode("a", {
          href: "https://krs.bz/suzuki/m?f=166",
          onClick: "s.linkTrackVars=prop13;s.prop13=四輪車トップ conv カタログ請求;s.tl(this, o, 四輪車トップ conv カタログ請求);",
          target: "_blank"
        }, [
          /*#__PURE__*/_createTextVNode("カタログ"),
          /*#__PURE__*/_createElementVNode("br", { class: "tab" }),
          /*#__PURE__*/_createTextVNode("請求")
        ])
      ]),
      /*#__PURE__*/_createElementVNode("li", { class: "yonrin-rightmenu yonrin-small" }, [
        /*#__PURE__*/_createElementVNode("a", { href: "https://www.suzuki.co.jp/car/" }, [
          /*#__PURE__*/_createTextVNode("四輪トップへ"),
          /*#__PURE__*/_createElementVNode("br", { class: "tab" }),
          /*#__PURE__*/_createTextVNode("戻る")
        ])
      ]),
      /*#__PURE__*/_createElementVNode("li", { class: "yonrin-small" }, [
        /*#__PURE__*/_createElementVNode("a", { href: "https://www.suzuki.co.jp/car/buying/" }, [
          /*#__PURE__*/_createTextVNode("購入を"),
          /*#__PURE__*/_createElementVNode("br", { class: "tab" }),
          /*#__PURE__*/_createTextVNode("お考えの方")
        ])
      ]),
      /*#__PURE__*/_createElementVNode("li", { class: "yonrin-small" }, [
        /*#__PURE__*/_createElementVNode("a", { href: "https://www.suzuki.co.jp/car/afterservice/" }, [
          /*#__PURE__*/_createTextVNode("オーナー"),
          /*#__PURE__*/_createElementVNode("br", { class: "tab" }),
          /*#__PURE__*/_createTextVNode("の方")
        ])
      ]),
      /*#__PURE__*/_createElementVNode("li", { class: "yonrin-small" }, [
        /*#__PURE__*/_createElementVNode("a", { href: "https://www.suzuki.co.jp/car/entertainment/" }, [
          /*#__PURE__*/_createTextVNode("スズキを"),
          /*#__PURE__*/_createElementVNode("br", { class: "tab" }),
          /*#__PURE__*/_createTextVNode("楽しむ")
        ])
      ]),
      /*#__PURE__*/_createElementVNode("li", { class: "yonrin-small" }, [
        /*#__PURE__*/_createElementVNode("a", {
          href: "https://www.suzuki.co.jp/ucar/",
          target: "_blank"
        }, [
          /*#__PURE__*/_createTextVNode("中古車"),
          /*#__PURE__*/_createElementVNode("br", { class: "tab" }),
          /*#__PURE__*/_createTextVNode("情報")
        ])
      ]),
      /*#__PURE__*/_createElementVNode("li", { class: "yonrin-small" }, [
        /*#__PURE__*/_createElementVNode("a", {
          href: "https://www.suzuki.co.jp/recall/",
          target: "_blank"
        }, [
          /*#__PURE__*/_createTextVNode("リコール等"),
          /*#__PURE__*/_createElementVNode("br", { class: "tab" }),
          /*#__PURE__*/_createTextVNode("情報")
        ])
      ])
    ])
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _hoisted_2
  ], 64))
}